module.exports = __webpack_public_path__ + "img/8.f2c7a6f9.jpg";